export default "__VITE_ASSET__DJDLyEqj__"